// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".application-sent__related__wrapper[data-v-2b9f6a74]{margin:0 -3.125rem;padding:0 3.125rem;border-top:1px solid #e8e9ea}", ""]);
// Exports
module.exports = exports;
